module.exports = __webpack_public_path__ + "img/MIDI.5c7d74d3.png";